import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL, FOREST_LOGO } from 'src/config';

const Logo = ({ logoFileName = FOREST_LOGO, ...props }) => {
  return (
    <img
      alt="Logo"
      src={`${BASE_URL}/static/${logoFileName}.png`}
      height={36}
      // width={98}
      {...props}
    />
  );
};

Logo.propTypes = {
  logoFileName: PropTypes.string
};

export default Logo;
